import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
const ShowDeleteModal = ({ open, onConfirm, onCancel }) => {
  return (
    <Modal show={open} onHide={onCancel} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to delete this document?</p>
        <p style={{ color: "#999", fontSize: "14px" }}>
          This action cannot be undone.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShowDeleteModal;
